import { window } from "../window";

/**
 * Retrieves the value of a specified search parameter from the current URL's query string.
 */

export const getSearchParam = (searchParam: string): string | null => {
  const searchParams = new window.URLSearchParams(window?.location?.search);

  return searchParams.get(searchParam);
};
